import { render } from "./PersonalDataConsentView.vue?vue&type=template&id=59973028&scoped=true"
import script from "./PersonalDataConsentView.vue?vue&type=script&lang=js"
export * from "./PersonalDataConsentView.vue?vue&type=script&lang=js"

import "./PersonalDataConsentView.css?vue&type=style&index=0&id=59973028&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59973028"]])

export default __exports__